import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import './AddRoomPage.css';
import Tabbar from '../../../Components/Tabbar/Tabbar';
import { getAll, add, clearErrs } from '../../../Store/Actions/RestActions';
import RoomsEditAddComponent from "../../../Components/Pages/RoomsEditAddComponent";
import Modal from 'react-modal';
import ErrorModal from '../../../Components/errorModal';

class AddRoomPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			accountId: localStorage.getItem("accountId"),
			name: '',
			description: '',
			isReservable: true,
			roomType: [],
			roomDetails: [],
			modalIsOpen: false,
			modal2IsOpen: false,
			isActive: true
		};
		this.form = true;
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
		this.handleCheckboxAndInputChange = this.handleCheckboxAndInputChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.openModal = this.openModal.bind(this);
		this.afterOpenModal = this.afterOpenModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.openModal2 = this.openModal2.bind(this);
		this.afterOpenModal2 = this.afterOpenModal2.bind(this);
		this.closeModal2 = this.closeModal2.bind(this);
	}

	componentDidMount() {
		// this.props.roomFetch();
		this.props.roomTypeFetch();
		// this.props.resourceTypeFetch();
		this.props.roomDetailTypesFetch();
		this.props.buildingsFetch();
		this.props.floorsFetch();
		this.props.assetsFetch();
	}

	handleInputChange(event) {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;
		this.setState({
			[name]: value,
		});
	}

	handleCheckboxChange(roomType) {
		this.setState({ roomTypeId: roomType[0] });
	}

	handleCheckboxAndInputChange(roomDetails) {

		this.setState({ roomDetails });
	}

	handleSubmit(event) {
		event.preventDefault();
		this.props.addRoom(this.state);
	}

	openModal() {
		this.setState({ modalIsOpen: true });
	}

	afterOpenModal() {
		// references are now sync'd and can be accessed.
	}

	closeModal() {
		this.setState({ modalIsOpen: false });
	}

	closeModal2() {
		this.setState({ modal2IsOpen: false });
	}

	openModal2() {
		this.setState({ modal2IsOpen: true, modalIsOpen: false });
	}

	afterOpenModal2() {
		// references are now sync'd and can be accessed.
	}


	render() {
		if (this.props.fireRedirect) {
			return (
				<Redirect to="/rooms" />
			);
		}
		return (
			<div className="container">
				<Tabbar setActiveTab="rooms" />
				<div className="contentBox tabbed-content-box addRoom">
					<h3>Add Room</h3>
					<RoomsEditAddComponent
						{...this.props}
						addLabel={true}
						state={this.state}
						handleCheckboxAndInputChange={this.handleCheckboxAndInputChange}
						handleCheckboxChange={this.handleCheckboxChange}
						handleInputChange={this.handleInputChange}
						handleSubmit={this.handleSubmit}
					/>
					<Modal
						isOpen={this.state.modalIsOpen}
						onAfterOpen={this.afterOpenModal}
						onRequestClose={this.closeModal}
						className="Modal"
						overlayClassName="Overlay"
						contentLabel="Cool Modal"
					>
						<h2 ref={subtitle => this.subtitle = subtitle}>Make a detail</h2>
						<button onClick={this.closeModal}>close</button>
						<div>Cool modal, yo.</div>
						<form>
							<input />
							<input />
						</form>
						<button className="modalBtn" onClick={this.openModal2}>next modal</button>
					</Modal>
					<Modal
						isOpen={this.state.modal2IsOpen}
						onAfterOpen={this.afterOpenModal2}
						onRequestClose={this.closeModal2}
						className="Modal"
						overlayClassName="Overlay"
						contentLabel="Next Modal"
					>
						<h2 ref={subtitle => this.subtitle = subtitle}>Next Modal</h2>
						<button onClick={this.closeModal2}>close</button>
						<div>Next Modal</div>
						<form>
							<input />
							<input />
						</form>
					</Modal>
				</div>
				<ErrorModal error={this.props.error} errMsg={this.props.errMsg} formError={this.props.formError} onClose={this.props.clearError}></ErrorModal>

			</div>
		);
	}
}
const mapStateToProps = state => ({
	roomDetailTypes: state.roomDetailTypes.data,
	roomTypes: state.roomTypes.data,
	resources: state.assets.data,
	buildings: state.buildings.data,
	floors: state.floors.data,
	error: state.rooms.hasError,
	errMsg: state.rooms.errMsg,
	fireRedirect: state.rooms.redirect
});

const mapDispatchtoProps = dispatch => ({
	// roomFetch: () => dispatch(getRooms()),
	roomTypeFetch: () => dispatch(getAll('roomtypes', {})),
	roomDetailTypesFetch: () => dispatch(getAll('roomdetailtypes', {})),
	assetsFetch: () => dispatch(getAll('assets', {})),
	buildingsFetch: () => dispatch(getAll('buildings', {})),
	floorsFetch: () => dispatch(getAll('floors', {})),
	addRoom: (data) => dispatch(add('rooms', data)),
	clearError: () => dispatch(clearErrs('rooms'))
});

export default connect(mapStateToProps, mapDispatchtoProps)(AddRoomPage);



// WEBPACK FOOTER //
// ./src/Pages/Rooms/RoomAdd/AddRoomPage.js